export default __webpack_public_path__ + "static/media/durvis-19-min.436bb3c6.jpg";